import { useState, useEffect } from "react"
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog"
import { Button } from "@/components/ui/button"
import { toast } from "sonner"
import { updateProjectDetail } from "@/api/projects"
import { ConstructionAdminServices } from "@/interfaces/project_types"

export function InteractableCAS({ cas, project_id }: { cas: ConstructionAdminServices | undefined, project_id: string }) {
    const [currentCAS, setCurrentCAS] = useState<ConstructionAdminServices>(cas ?? "No")
    const [isDialogOpen, setIsDialogOpen] = useState(false)
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        setCurrentCAS(cas ?? "No")
    }, [cas])

    const handleConfirm = async () => {
        setIsLoading(true)
        try {
            const status = await updateProjectDetail(project_id, "construction_admin_services", "Completed")
            if (status === 200) {
                setCurrentCAS("Completed")
                setIsDialogOpen(false)
                toast.success("CAS marked as Completed")
            } else {
                toast.error("Failed to update CAS")
            }
        } catch {
            toast.error("Failed to update CAS")
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
            <DialogTrigger asChild>
                <Button
                    variant="ghost"
                    disabled={currentCAS === "Completed"}
                    className="h-auto p-2 font-medium bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 disabled:opacity-100"
                >
                    {currentCAS}
                </Button>
            </DialogTrigger>
            <DialogContent className="sm:max-w-md">
                <DialogHeader>
                    <DialogTitle>Mark CAS as Completed?</DialogTitle>
                </DialogHeader>
                <p className="text-sm text-muted-foreground">
                    This will mark Construction Admin Services as <span className="font-medium text-foreground">Completed</span> for this project. This cannot be undone from the table.
                </p>
                <DialogFooter>
                    <Button variant="outline" onClick={() => setIsDialogOpen(false)} disabled={isLoading}>
                        Cancel
                    </Button>
                    <Button onClick={handleConfirm} disabled={isLoading}>
                        {isLoading ? "Updating..." : "Mark Completed"}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}
